module.exports = __webpack_public_path__ + "media/waiteriscalled.1398489d.mp3";